import styled from 'styled-components';

/* Static warm wash at the top of the page. Not cursor-driven; it warms the hero. */
export const AmbientWash = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 720px;
  pointer-events: none;
  background: radial-gradient(900px 480px at 20% -10%, var(--accent-soft), transparent 65%),
    radial-gradient(720px 420px at 85% -5%, var(--findy-soft), transparent 60%);
  z-index: -1;
`;

/* First focusable on the page. Off-screen until focused. */
export const SkipLink = styled.a`
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 1200;
  padding: 12px 18px;
  background: var(--ink);
  color: var(--ink-inverse);
  font-family: var(--font-body);
  font-size: var(--t-small);
  border-radius: var(--radius-pill);
  transform: translateY(-200%);
  transition: transform var(--d-micro) var(--ease-quick);

  &:focus {
    transform: none;
  }
`;

export const Main = styled.main`
  position: relative;
`;

/* Route transition (g.5): the outgoing view fades while a night panel wipes in from the top. */
export const View = styled.div<{ $phase: 'idle' | 'out' | 'in' }>`
  opacity: ${p => (p.$phase === 'out' ? 0 : 1)};
  transition: opacity var(--d-micro) var(--ease-quick);
`;

export const Curtain = styled.div<{ $phase: 'idle' | 'out' | 'in' }>`
  position: fixed;
  inset: 0;
  z-index: 1150;
  background: var(--night-0);
  pointer-events: none;
  transform-origin: top center;
  transform: scaleY(${p => (p.$phase === 'idle' ? 0 : 1)});
  opacity: ${p => (p.$phase === 'in' ? 0 : 1)};
  transition: ${p =>
    p.$phase === 'out'
      ? 'transform var(--d-ui) var(--ease-swap)'
      : p.$phase === 'in'
      ? 'opacity var(--d-ui) var(--ease-quick)'
      : 'none'};
`;
